
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.995 .995)","stroke":"#000","stroke-width":"1.5","fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"11.005","cy":"11.005","r":"10.317"}}),_c('path',{attrs:{"d":"M3.71 3.71L18.3 18.3"}})])])
          )
        }
      }
    